export default function CustomTestingProcedureDirective() {
  return {
    template: require('./custom-testing-procedure.html'),
    scope: {
      assessmentId: '=',
      assessmentCustomTestProcedure: '=',
      status: '@',
      includeKeyContacts: '@',
    },
    controller: 'CustomTestingProcedureController',
    controllerAs: 'customTestingProcedureVM',
    bindToController: true,
    replace: true,
  };
}
